// The footer contains company address, phone and email Info, website information disclaimer and developer information 

import { Component } from "react";
import './Footer.css';
import FooterImage from '../images/logo192.png';
import Email from '../images/email.png';
import Call from '../images/call.png';

class Footer extends Component {
    render() {
        return (
            <>
            <div className="Footer">
                <img className="logo-footer" alt="logo" src={FooterImage} />
                <address className="address">
                    <p> &copy; 2009 ANA IT Solutions</p>
                    <p>6900 Dillingwood Drive</p>
                    <p>Mississauga, Ontario L5N 6Z7</p>
                </address>
                <div className="email">
                    <img alt="email-img" src={Email}/><a href="mailto:info@anait.ca">info@anait.ca</a>
                </div>
                <div className="phone">
                    <img alt="phone-img" src={Call}/><span>647-290-0267</span>
                </div>
                <div className="disclaimer">The information available on ANA IT INC. website is for general information purposes only. ANA IT INC. assumes no responsibility for errors or ommissions in the contents on the Service.</div>
            </div>
            <div>                
                <footer>Website Design and Development by <a href="https://creativewebprojects.tech/portfolio" title="https://creativewebprojects.tech/portfolio" target="_blank" rel="noreferrer" >Hina Raza</a></footer>
            </div>
            </>
        );
    }

}

export default Footer;